import {DomainEvent} from './DomainEvent';
import {Gallery} from '../resources/Gallery';

export class MatchGalleryRemoved extends DomainEvent<Gallery> {}
